import { render, staticRenderFns } from "./DetailBudgetPlan.vue?vue&type=template&id=b12169bc"
import script from "./DetailBudgetPlan.vue?vue&type=script&lang=js"
export * from "./DetailBudgetPlan.vue?vue&type=script&lang=js"
import style0 from "./DetailBudgetPlan.vue?vue&type=style&index=0&id=b12169bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports